import { memo, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as AntLayout } from 'antd';

import { AffiliateMenu } from '@/widgets/layout';

import { AffiliateJoin } from '@/features/affiliate-join';

import { useGetReferralMeQuery } from '@/entities/affiliate';

import { Loader } from '@/shared/ui/loader';
import { PageLoader } from '@/shared/ui/page-loader';

import cls from './affiliate-layout.module.css';

export const AffiliateLayout = memo(() => {
    const { data: me, isLoading } = useGetReferralMeQuery();

    if (isLoading) {
        return (
            <div className={cls.loaderContainer}>
                <Loader />
            </div>
        );
    }

    // Not enrolled yet: show the join hero full-width, without the tab header.
    if (!me?.enrolled) {
        return <AffiliateJoin program={me?.program} />;
    }

    return (
        <AntLayout className={cls.layout}>
            <AffiliateMenu />
            <AntLayout.Content className={cls.content}>
                <Suspense fallback={<PageLoader />}>
                    <Outlet />
                </Suspense>
            </AntLayout.Content>
        </AntLayout>
    );
});

AffiliateLayout.displayName = 'AffiliateLayout';
